export const LISTINGS_PER_PAGE = 60;
export const SEARCH_TIMEOUT_MS = 10000;
export const QUERY_TYPES = ['ELASTIC_SEARCH', 'VAAS', 'LLM'];
export const DEFAULT_QUERY_TYPE = 'ELASTIC_SEARCH';